import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import _get from 'lodash/get';
import PropTypes from 'prop-types';
// Models
import { sortElements as sortCompanies } from 'models/company';
import { sortElements as sortProfiles } from 'models/profile';
// Custom
import { profileDataShape, companyDataShape } from 'constants/PropTypesShapes';
import { completeFormErrors } from 'utils/Forms';
import withFormManagement from 'hocs/WithFormManagement';
import ResourcesSelectField from 'components/inputFields/ResourcesSelectField';

class UserPermissionAdd extends React.Component {
  constructor(props) {
    super(props);

    this.handleValidate = this.handleValidate.bind(this);
  }

  componentDidMount() {
    // We need to pass component reference to parent (= DialogItem)
    const { onRef } = this.props;
    onRef(this);
  }

  // Handlers called by parent (= DialogItem)
  handleValidate() {
    const {
      fields: { companyId, profileId },
      onErrorsChange,
      onValidate,
    } = this.props;

    let errors;
    if (!profileId) {
      errors = completeFormErrors(errors, 'profileId', ['cantBeBlank']);
    }
    // Apply errors
    onErrorsChange(errors);

    // No error => validate form
    if (!errors) {
      onValidate({
        company_id: companyId,
        profile_id: profileId,
      });
      return true;
    }

    return false;
  }

  render() {
    const {
      fields: { companyId, profileId },
      errors,
      companyList,
      profileList,
      onFieldsChange,
    } = this.props;

    return (
      <div className="row">
        <div className="col-12">
          <ResourcesSelectField
            label={<LocalizedMessage id="field.company" />}
            value={companyId}
            resources={sortCompanies(companyList)}
            displayKey="name"
            onChange={(value) => onFieldsChange({ companyId: value })}
          />
        </div>
        <div className="col-12">
          <ResourcesSelectField
            label={<LocalizedMessage id="field.profile" />}
            value={profileId}
            errorText={_get(errors, 'profileId')}
            resources={sortProfiles(profileList)}
            displayKey="name"
            required
            onChange={(value) => onFieldsChange({ profileId: value })}
          />
        </div>
      </div>
    );
  }
}

UserPermissionAdd.propTypes = {
  companyList: PropTypes.arrayOf(companyDataShape),
  profileList: PropTypes.arrayOf(profileDataShape),
  fields: PropTypes.object.isRequired,
  errors: PropTypes.object,
  onFieldsChange: PropTypes.func.isRequired,
  onErrorsChange: PropTypes.func.isRequired,
  onRef: PropTypes.func.isRequired,
  onValidate: PropTypes.func.isRequired,
};

UserPermissionAdd.defaultProps = {
  errors: null,
  companyList: [],
  profileList: [],
};

const mapStateToProps = (state) => ({
  companyList: _get(state.company.list, 'flattenElements'),
  profileList: _get(state.profile.list.elements, 'data'),
});

const mapFieldsToProps = {
  companyId: {
    defaultValue: null,
  },
  profileId: {
    defaultValue: null,
  },
};

module.exports = compose(
  connect(mapStateToProps),
  withFormManagement(mapFieldsToProps, null, false),
)(UserPermissionAdd);



// WEBPACK FOOTER //
// ./routes/app/routes/users/assets/main/UserPermissionAdd.js